import { DropdownListItem } from '@toggle/design-system';
import { Condition } from '@toggle/toggle';
import React, { FC, useEffect, useState } from 'react';

import { useFilteredTimeSeries } from '~/hooks/use-timeseries/useTimeSeries';

import * as S from './ConditionDataList.styles';

export interface ConditionDataListProps {
  currentPayload: Condition;
  response: (editedPayload: Partial<Condition>) => void;
}

export const ConditionDataList: FC<ConditionDataListProps> = ({
  currentPayload,
  response,
}) => {
  const { data: snakeItems } = useFilteredTimeSeries([currentPayload.entity]);
  const [dataLabels, setDataLabels] = useState<string[]>([]);

  useEffect(() => {
    if (snakeItems) {
      setDataLabels(
        snakeItems
          ?.filter(({ search: { rank } }) => rank !== -1)
          .sort((a, b) => b.search.rank - a.search.rank)
          ?.map(items => items.name.english) ?? []
      );
    }
  }, [snakeItems]);

  const handleClick = (value: string, index: number) => {
    const editedPayload = {
      snake: snakeItems?.[index].snake ?? '',
      snakeName: value,
    };
    response(editedPayload);
  };

  return (
    <S.ConditionDataDropdown
      dropdownItems={dataLabels}
      shouldShowItems={false}
      placement="bottom-start"
      inPortal
      selectItem={(item, __, index) => {
        handleClick(item, index);
      }}
      renderDropdownItem={(item, isActive, isFocused) => (
        <DropdownListItem
          data-testid="conditional-data-item"
          key={item}
          label={item}
          supportiveText={''}
          isActive={isActive}
          isFocused={isFocused}
        />
      )}
    >
      <S.StyledSelect
        inputProps={{ value: currentPayload.snakeName }}
        isActive={false}
      />
    </S.ConditionDataDropdown>
  );
};
